import React, { useEffect } from 'react';
import { useLogger } from '~Hooks';

import { gql, useMutation } from '@apollo/client';
import { AdyenBackendRefund, AdyenBackendRefundVariables } from './__queries__';
import { ORDER_ORIGIN } from '~../__queries__';
import { RefundProps } from '../types';

const ADYEN_REFUND_REQUEST = gql`
  mutation AdyenBackendRefund($transactionId: String, $amount: Int) {
    posAdyenRefundRequest(transactionId: $transactionId, amount: $amount) {
      success
      message
      method
      cardIdentifier
    }
  }
`;

/*
 * RefundAdyenBackend makes a backend requests to refund the adyen payment through
 * a lambda that is created purely for POS Backend refunds.
 *
 * It takes in a pspReference (Adyens terminology for payment ID)
 */
const RefundAdyenBackend = (props: RefundProps) => {
  const { amount, onCompleted, onFail, transactionId } = props;

  const [adyenRefundRequest] = useMutation<AdyenBackendRefund, AdyenBackendRefundVariables>(
    ADYEN_REFUND_REQUEST,
  );
  const logger = useLogger('refund-adyen');

  useEffect(() => {
    if (amount === 0) {
      logger.info('Refund - Amount is 0, no need to refund');

      onCompleted();
      return;
    }

    adyenRefundRequest({
      variables: {
        transactionId: transactionId,
        amount,
      },
      fetchPolicy: 'no-cache',
    })
      .then(({ data }) => {
        if (!data?.posAdyenRefundRequest.success) {
          throw new Error(data?.posAdyenRefundRequest.message ?? 'Unknown error');
        }

        // Refund successful.
        logger.info('Refund - Adyen Backend Refund successful on TransactionId: ' + transactionId);
        onCompleted();
      })
      .catch((e) => {
        logger.error('Refund - Adyen Backend Refund failed on TransactionId: ' + transactionId, {
          errorMessage: e.message,
        });
        onFail();
      });
  }, []);

  return <></>;
};

export default RefundAdyenBackend;
